import { Command } from '@/app/common/base/command'
import { Dictionary } from '@/app/dictionary/entities/dictionary.entity'

export class GetDictionaryCommand extends Command {
    public async run(): Promise<Dictionary[]> {
        const response = await this.client.get('/api/dictionary')
        return response.asEntities(Dictionary)
    }
}
